// extracted by mini-css-extract-plugin
export default {"wrapper":"seventhTypeSandbox_wrapper__0pFav","question":"seventhTypeSandbox_question__9cbHv","image":"seventhTypeSandbox_image__QM5KM","options":"seventhTypeSandbox_options__+gIoW"};